import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.25 1.167H1.75a.583.583 0 0 0-.583.583v10.5a.583.583 0 0 0 .583.583h10.5a.583.583 0 0 0 .583-.583V1.75a.583.583 0 0 0-.583-.583m-.583 10.5H2.333V5.833h9.334zm0-7H2.333V2.333h9.334z"
    }, null, -1)
  ])))
}
export default { render: render }